(function () {
  'use strict';

  var loc = window.location;
  var okPage =
    loc.protocol === 'https:' &&
    loc.hostname === 'www.deankeating.com' &&
    loc.port === '' &&
    !loc.username &&
    !loc.password &&
    /^\/pages\/(?:ai-business-coach|ai-in-action)\/?$/.test(loc.pathname);
  if (!okPage) return;

  var BOUND = 'dkCookieChoicesBound';
  var UNAVAILABLE =
    'Cookie choices are not available right now. Please try again shortly.';

  function setStatus(box, text) {
    if (box) box.textContent = text || '';
  }

  function bind(button) {
    if (button.dataset[BOUND] === '1') return;
    button.dataset[BOUND] = '1';

    var wrap = button.parentNode;
    var status = wrap ? wrap.querySelector('[data-dk-cookie-status]') : null;
    var busy = false;

    function finish(failed) {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (failed) setStatus(status, UNAVAILABLE);
      var active = document.activeElement;
      if (!active || active === document.body) {
        try { button.focus(); } catch (e) { /* ignore */ }
      }
    }

    button.addEventListener('click', function (event) {
      if (!event.isTrusted || busy) return;
      setStatus(status, '');

      var banner = window.privacyBanner;
      if (!banner || typeof banner.showPreferences !== 'function') {
        setStatus(status, UNAVAILABLE);
        return;
      }

      busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      var settled = false;
      function once(failed) {
        if (settled) return;
        settled = true;
        finish(failed);
      }

      var result;
      try {
        result = banner.showPreferences();
      } catch (err) {
        once(true);
        return;
      }

      if (result && typeof result.then === 'function') {
        try {
          result.then(
            function () { once(false); },
            function () { once(true); }
          );
        } catch (err2) {
          once(true);
        }
      } else {
        once(false);
      }
    });
  }

  function init() {
    var buttons = document.querySelectorAll('button[data-dk-cookie-choices]');
    for (var i = 0; i < buttons.length; i++) bind(buttons[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
